import type { SortingState } from '@tanstack/react-table';
import { useState } from 'react';

const getStringParams = (sorting: SortingState) => {
  return sorting.reduce<string[]>((acc, { id, desc }) => {
    acc.push(`${id}:${desc ? 'desc' : 'asc'}`);

    return acc;
  }, []);
};

/*
  applies default sorting when no other sorting is applied
  this sorting is not visible to the user
 */
export const useDefaultSort = (defaultServerSorting: SortingState = []) => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const sortingParams = sorting.length ? sorting : defaultServerSorting;

  const sortingParamsStr = getStringParams(sortingParams);

  return {
    sorting,
    setSorting,
    orderBy: sortingParamsStr.join(','),
  };
};
